"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FuseDirectivesModule {
}
exports.FuseDirectivesModule = FuseDirectivesModule;
